import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M10.313 14.719H4.686c-2.062 0-2.343-1.125-2.343-2.344V6.888c0-.257.212-.47.469-.47.256 0 .468.213.468.47v5.487c0 1.088.188 1.406 1.406 1.406h5.625c1.22 0 1.407-.318 1.407-1.406V6.888c0-.257.212-.47.469-.47.256 0 .468.213.468.47v5.487c0 1.219-.281 2.344-2.344 2.344Z" }),
      _createElementVNode("path", { d: "M11.875 7.219h-8.75c-1.512 0-2.344-.832-2.344-2.344v-1.25c0-1.513.832-2.344 2.344-2.344h8.75c1.512 0 2.344.831 2.344 2.344v1.25c0 1.513-.832 2.344-2.344 2.344m-8.75-5c-.987 0-1.406.419-1.406 1.406v1.25c0 .987.419 1.406 1.406 1.406h8.75c.988 0 1.406-.418 1.406-1.406v-1.25c0-.987-.418-1.406-1.406-1.406zm5.512 7.5H6.362a.47.47 0 0 1-.468-.469c0-.256.212-.469.468-.469h2.275c.257 0 .469.213.469.469a.47.47 0 0 1-.469.469" })
    ], -1)
  ]))]))
}
export default { render: render }